import { AriaRole, ReactNode } from "react";
import { twMerge } from "tailwind-merge";

interface CardProps {
    title?: ReactNode;
    description?: ReactNode;
    titleAction?: ReactNode;
    footer?: ReactNode;
    children?: ReactNode;
    className?: string;
    onClick?: React.MouseEventHandler<HTMLDivElement>;
    onKeyDown?: React.KeyboardEventHandler<HTMLDivElement>;
    role?: AriaRole;
    tabIndex?: number;
}

const Card = (props: CardProps) => {
    const {
        title,
        description,
        titleAction,
        footer,
        children,
        className,
        onClick,
        onKeyDown,
        role,
        tabIndex,
    } = props;

    return (
        <div
            data-card
            role={role}
            tabIndex={tabIndex}
            onClick={onClick}
            onKeyDown={onKeyDown}
            className={twMerge(
                "flex flex-col gap-4 rounded-md border border-surface-550 bg-surface-500 px-5 py-4 shadow-xs in-data-card:shadow-[0_1px_3px_rgba(0,0,0,0.05)]!",
                onClick &&
                    "cursor-pointer transition-[border-color,box-shadow,background-color] duration-150 hover:border-primary-250 hover:bg-surface-515 hover:shadow-[0_3px_9px_rgba(0,0,0,0.08)]!",
                className
            )}
        >
            {(title || description || titleAction) && (
                <div data-card-header className="flex items-center justify-between gap-4">
                    <div className="flex flex-col gap-0.5 flex-1 min-w-0">
                        {title && (
                            <div className="card-title">
                                {title}
                            </div>
                        )}
                        {description && <div className="text-xs text-text-300">{description}</div>}
                    </div>
                    {titleAction && (
                        <div className="flex-none">{titleAction}</div>
                    )}
                </div>
            )}
            {children}
            {footer}
        </div>
    );
};

export default Card;
